import { useSprintQueryClient } from "sprint-common-web";

import { GetSingleAncillaryResponse } from "../../../api/catalogue-api/ancillary/GetSingleAncillaryResponse";
import { useCatalogueAncillarySearchApi } from "../../../api/catalogue-api/ancillary/useCatalogueAncillarySearchApi";
import { AncillaryQueryKey } from "./keys/AncillaryQueryKey";

export const useGetAncillaryById = () => {
    const queryClient = useSprintQueryClient();
    const { getSingleAncillary: getAncillaryByIdUncached } = useCatalogueAncillarySearchApi();

    const getAncillaryById = (ancillaryId: string): Promise<GetSingleAncillaryResponse> => {
        return queryClient.fetchQuery({
            queryKey: [AncillaryQueryKey.AncillaryDetails, ancillaryId],
            queryFn: () => getAncillaryByIdUncached(ancillaryId),
            staleTime: 20000
        });
    };

    return { getAncillaryById };
};
